export const DOWNLOAD_APP_MODAL_BUTTON_TEST_ID = 'DownloadAppModalButton';
export const DOWNLOAD_APP_MODAL_QRCODE_TEST_ID = 'DownloadAppModalQRCode';
